var merge = require('webpack-merge');
import Vue from 'vue';

var config = {};
if (process.env.NODE_ENV === 'production') { // 打包后线上
  config = merge(config, {
    domain: {
      backstage: 'https://gwck.gxwhcy.com/apiserver',
      front: "https://prm.junziqian.com",
      transpont: "https://account.ebaoquan.org/asset/pointChargePage",
      pdfs: 'https://cdn.ebaoquan.org'
    }
  });
} else if (process.env.NODE_ENV === 'sandbox') { // 打包后沙箱
  config = merge(config, {
    domain: {
      backstage: 'https://prm.sandbox.junziqian.com',
      front: "https://prm.sandbox.junziqian.com",
      transpont: "https://account-sandbox.ebaoquan.org/asset/pointChargePage",
      pdfs: 'https://cdn.ebaoquan.org'
    }
  })
} else {
  config = merge(config, {
    domain: {
      backstage: window.location.protocol + '//' + window.location.host + '/api',
      //backstage: 'http://prm.sandbox.junziqian.com',
      pdfs: window.location.protocol + '//' + window.location.host + '/pdfs',
      // backstage: 'http://prm.sandbox.junziqian.com',
      front: window.location.protocol + '//' + window.location.host,
      transpont: "https://account-sandbox.ebaoquan.org/asset/pointChargePage",
    }
  });
}
export default config
Vue.prototype.globalConfig = config;



// WEBPACK FOOTER //
// ./src/common/js/global-config.js